<div class="container">
  <div class="row">
    <div class="col" style="margin: 15px 0;">
      <h2>Система управления</h2>
      <p>Единственный учредитель и генеральный директор резидент Российской Федерации Тищенко
        Наталья Владимировна.</p>
      <p>Руководство текущей деятельностью осуществляется единоличным исполнительным органом -
        генеральным директором.</p>
      <p>Генеральный директор Общества:</p>
      <ul>
        <li>без доверенности действует от имени Общества, в том числе представляет его интересы и
          совершает сделки;</li>
        <li>издает приказы о назначении на должности работников Общества, об их переводе и увольнении,
          применяет меры поощрения и налагает дисциплинарные взыскания;</li>
        <li>открывает расчетные и иные счета в банках;</li>
        <li>утверждает (принимает) документы, регулирующие текущую деятельность Общества;</li>
        <li>осуществляет иные функции, предусмотренные Уставом Общества.</li>
      </ul>

      <p>Система вознаграждения в Обществе осуществляется на основании приказов генерального
        директора в соответствии с внутренним положением об оплате труда и премировании.</p>
    </div>
  </div>
</div>
